import styled from 'styled-components'

export const PageContent = styled.section`
  max-width: 900px;
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
`
